import React from 'react';
import { getActiveChartTypeOption } from '@/components/Editor/Form/fields/ChartType/utils';
import GeneralRevealPill from '@/components/Editor/Form/fields/GeneralRevealPill';
import { CHART_TYPES } from './settings';
import { jsx as _jsx } from "react/jsx-runtime";

const WidgetEditFormPieDoughnutChartFields = _ref => {
  let {
    config,
    title,
    pillVariant,
    onChartSelect
  } = _ref;
  const currentChartType = config.chartType || 'doughnut';
  const {
    currentChartTypeOption
  } = getActiveChartTypeOption(currentChartType, CHART_TYPES);
  return /*#__PURE__*/_jsx(GeneralRevealPill, {
    title: title ?? 'Pie Chart',
    pillVariant: pillVariant,
    leftIcon: currentChartTypeOption === null || currentChartTypeOption === void 0 ? void 0 : currentChartTypeOption.icon,
    onChartSelect: onChartSelect
  });
};

export default WidgetEditFormPieDoughnutChartFields;